import { render, staticRenderFns } from "./roomTemplatePull.vue?vue&type=template&id=67d214d3&scoped=true"
import script from "./roomTemplatePull.vue?vue&type=script&lang=js"
export * from "./roomTemplatePull.vue?vue&type=script&lang=js"
import style0 from "./roomTemplatePull.vue?vue&type=style&index=0&id=67d214d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d214d3",
  null
  
)

export default component.exports